import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function OutreachPillars({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((o, i) => {
            const I = getIcon(o.icon);
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div className="group p-8 rounded-3xl bg-white shadow-soft hover:-translate-y-1 transition h-full">
                  <div className="inline-flex h-14 w-14 rounded-2xl bg-olive text-white items-center justify-center group-hover:bg-accent group-hover:text-ink transition"><I size={24} /></div>
                  <EditableText value={o.title} onChange={(t) => updateItem(i, { title: t })} as="h4" className="font-display text-xl mt-5" />
                  <EditableText value={o.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="mt-3 text-ink/70 text-sm leading-relaxed" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default OutreachPillars;
